import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_an/step3';
import { TypeFNSSimpleDescMarche2 } from '../models/TypeFNSSimpleDescMarche2';
import { SimpANControlNames } from '../simpANControleNames';
@Component({
	selector: 'app-typeFNS-simple-desc-marche2',
	templateUrl: './typeFNS-simple-desc-marche2.component.html'
})
export class TypeFNSSimpleDescMarche2Component implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeFNSSimpleDescMarche2';
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() natureMarche: TypeFNSSimpleDescMarche2;

	public step3 = new Step3();

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}
}
